import { trackEvent } from 'ddc-track-event';

export const trackGalleryEvent = ({
	widgetName,
	windowId,
	action,
	element,
	elementCTA,
	result,
	currentItem,
	totalItems,
	carouselDirection
}) => {
	const pubsub = window?.DDC?.pubsub;

	if (pubsub) {
		pubsub?.publish('wsm-vehicle-toast/interacted-vehicles', {
			interaction: 'ddc-vehicle-gallery-opened',
			timestamp: Date.now(),
			uuid: window?.DDC?.dataLayer?.vehicles[0].uuid,
			widgetName
		});
	}
	trackEvent(widgetName, windowId, {
		action,
		...(currentItem && { currentItem }),
		...(totalItems && { totalItems }),
		element,
		elementCTA,
		nonInteractive: false,
		result,
		...(carouselDirection && { carouselDirection })
	});
};

export const galleryTrackingEvents = {
	openModal: (widgetName, windowId, { currentItem, totalItems }) =>
		trackGalleryEvent({
			widgetName,
			windowId,
			action: 'click',
			element: 'On Page Gallery photo',
			result: 'Open gallery modal',
			currentItem,
			totalItems
		}),

	clickThumbnail: (widgetName, windowId, { currentItem, totalItems }) =>
		trackGalleryEvent({
			widgetName,
			windowId,
			action: 'click',
			element: 'Photo Carousel thumbnail',
			result: 'Zoom into photo',
			currentItem,
			totalItems
		}),

	clickAllPhotosButton: (widgetName, windowId) =>
		trackGalleryEvent({
			widgetName,
			windowId,
			action: 'click',
			element: 'All Photos',
			elementCTA: 'All Photos thumbnail',
			result: 'Open gallery modal'
		}),

	clickVideoButton: (widgetName, windowId) =>
		trackGalleryEvent({
			widgetName,
			windowId,
			action: 'click',
			element: 'Video Button',
			elementCTA: 'Video',
			result: 'Open video in gallery modal'
		}),

	clickPhotoCountToolbar: (widgetName, windowId, { elementCTA }) =>
		trackGalleryEvent({
			widgetName,
			windowId,
			action: 'click',
			element: 'Photo Count Button',
			elementCTA,
			result: 'Open gallery modal'
		}),

	closeModal: (widgetName, windowId) =>
		trackGalleryEvent({
			widgetName,
			windowId,
			action: 'click',
			element: 'Photo Carousel close button',
			result: 'Close gallery modal'
		}),

	clickPhotosTab: (widgetName, windowId) =>
		trackGalleryEvent({
			widgetName,
			windowId,
			action: 'click',
			element: 'Photos Tab',
			elementCTA: 'Photos',
			result: 'Open photos tab'
		}),

	clickVideoTab: (widgetName, windowId) =>
		trackGalleryEvent({
			widgetName,
			windowId,
			action: 'click',
			element: 'Video Tab',
			elementCTA: 'Video',
			result: 'Open video tab'
		}),

	clickNextButton: (
		widgetName,
		windowId,
		{ result, currentItem, totalItems }
	) =>
		trackGalleryEvent({
			widgetName,
			windowId,
			action: 'click',
			element: 'Photo Carousel Next Button',
			result,
			currentItem,
			totalItems,
			carouselDirection: 'next'
		}),

	clickPrevButton: (
		widgetName,
		windowId,
		{ result, currentItem, totalItems }
	) =>
		trackGalleryEvent({
			widgetName,
			windowId,
			action: 'click',
			element: 'Photo Carousel Previous Button',
			result,
			currentItem,
			totalItems,
			carouselDirection: 'previous'
		}),

	swipeCarousel: (
		widgetName,
		windowId,
		{ result, currentItem, totalItems, carouselDirection }
	) =>
		trackGalleryEvent({
			widgetName,
			windowId,
			action: 'swipe',
			element: 'Photo Carousel',
			result,
			currentItem,
			totalItems,
			carouselDirection
		})
};
